/* lozenge-base.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./lozenge-base.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef, Fragment, memo } from 'react';
import { cx } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import Pressable from '@atlaskit/primitives/pressable';
import IconRenderer from './icon-renderer';
import { getThemeStyles, resolveLozengeColor } from './utils';
var styles = {
  container: "_2rko12b0 _1reo15vq _18m915vq _zulp1b66 _1rjcv77o _18zr1b66 _189ee4h9 _1dqonqa1 _1h6d1j28 _1e0c116y _4cvr1h6o _vchhusvi _4t3igktf",
  containerInteractive: "_80omtlke _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa",
  containerSelected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
  text: "_11c81o8v _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
  textSelected: "_syaz6x5g",
  'semantic.success': "_1b3i4pcx _3wu01mps _bfhk14j0 _syaz1p1e",
  'semantic.warning': "_1b3iervl _3wu01xiv _bfhk10f4 _syazmgs1",
  'semantic.danger': "_1b3is4qr _3wu01bqt _bfhk18wg _syaz1blx",
  'semantic.information': "_1b3iyhbg _3wu0vbh5 _bfhk8lbg _syaz1qd9",
  'semantic.neutral': "_1b3i1cv2 _3wu01ihb _bfhki8nm _syazi7uo",
  'semantic.discovery': "_1b3iqm1h _3wu0v30g _bfhke670 _syaz1g72",
  'accent.red': "_1b3inbxb _3wu016y8 _bfhk1rtt _syazhwvp",
  'accent.orange': "_1b3i1j6y _3wu01b2s _bfhk165s _syaz7i1p",
  'accent.yellow': "_1b3i1oqg _3wu0feiv _bfhk1773 _syazekll",
  'accent.lime': "_1b3i8645 _3wu0nf89 _bfhkz2ec _syaz1ik3",
  'accent.green': "_1b3i17hp _3wu01crs _bfhk1wnw _syaz1y78",
  'accent.teal': "_1b3i8uof _3wu01h3o _bfhk1a17 _syaz12v7",
  'accent.blue': "_1b3i6txe _3wu01w55 _bfhk1dy8 _syaz1kyx",
  'accent.purple': "_1b3iuq3u _3wu01hqq _bfhk1nm4 _syaz1mn1",
  'accent.magenta': "_1b3iv8hk _3wu0uwd0 _bfhkv9ra _syaz1qur",
  'accent.gray': "_1b3i1diz _3wu08yml _bfhkysee _syaz1tmo",
  'interactive.semantic.success': "_irr31r82 _1di6d6jc",
  'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
  'interactive.semantic.danger': "_irr370oi _1di6jkmi",
  'interactive.semantic.information': "_irr315aw _1di6ar1y",
  'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
  'interactive.semantic.discovery': "_irr3rumk _1di65usi",
  'interactive.accent.red': "_irr3affd _1di61j5a",
  'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
  'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
  'interactive.accent.lime': "_irr31gf0 _1di62kxc",
  'interactive.accent.green': "_irr31e2h _1di6ybhx",
  'interactive.accent.teal': "_irr3kwwr _1di61jb0",
  'interactive.accent.blue': "_irr3815t _1di6rwxf",
  'interactive.accent.purple': "_irr3attl _1di63nfk",
  'interactive.accent.magenta': "_irr31axx _1di642ri",
  'interactive.accent.gray': "_irr3wejn _1di618ut",
  selectedInteractive: "_irr3ufnl _1di6nozp",
  iconBorderFilter: "_1h6dzs9d _4uq11yqs _1k671038 _m71tr3uz _13muu67f _168qx19p _oe6mmko7 _189qkb7n _u8p61h4e _1t75u67f _hg5mr3uz _1f28f1ug _1xe213rw _1easxmrh _1r9r1ss3",
  iconBorderInteractiveFilter: "_1iel6xdd _111i1h4e _18dicjiy _hyog26zw _fdt01r5k _46v5hwvj _ylgq1r5k _bg3q9by0 _196p1btq _18mn783i _l0666xdd _pclnn8xv _ockq1r5k _aewt1n8h _4cvx7ddx _1cp21w66 _q4zt1csi _1gqs1mvc _75gv2l9f _1lh71sfd _ui3h1ct7 _11o31cha"
};

/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */
var LozengeBase = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    testId = _ref.testId,
    appearance = _ref.appearance,
    iconBefore = _ref.iconBefore,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick,
    style = _ref.style,
    analyticsContext = _ref.analyticsContext,
    interactionName = _ref.interactionName;
  var isInteractive = typeof onClick === 'function';

  // Determine the effective color, with fallback logic for legacy appearances
  var resolvedColor = resolveLozengeColor(appearance) || 'neutral';
  var _getThemeStyles = getThemeStyles(resolvedColor),
    category = _getThemeStyles.category,
    key = _getThemeStyles.key;
  var colorStyleKey = "".concat(category, ".").concat(key);
  var interactiveStyleKey = "interactive.".concat(category, ".").concat(key);
  var maxWidthValue = typeof maxWidth === 'string' ? maxWidth : "".concat(maxWidth, "px");
  var maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
  var commonStyleOverrides = {
    backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
    maxWidth: maxWidthIsPc ? maxWidth : '100%'
  };
  var innerContent = /*#__PURE__*/React.createElement(Fragment, null, iconBefore && /*#__PURE__*/React.createElement(IconRenderer, {
    icon: iconBefore,
    color: resolvedColor,
    isSelected: isInteractive ? isSelected : undefined,
    testId: testId && "".concat(testId, "--icon")
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      maxWidth: maxWidthIsPc ? '100%' : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")"),
      color: style === null || style === void 0 ? void 0 : style.color
    },
    "data-testid": testId && "".concat(testId, "--text"),
    className: ax([styles.text])
  }, children), isInteractive && /*#__PURE__*/React.createElement(ChevronDownIcon, {
    label: "",
    size: "small",
    color: isSelected ? "var(--ds-icon-selected, #1868DB)" : 'currentColor',
    testId: testId && "".concat(testId, "--chevron")
  }));
  if (isInteractive) {
    return /*#__PURE__*/React.createElement(Pressable, {
      ref: ref,
      xcss: cx(styles.container, !isSelected && styles.iconBorderFilter, !isSelected && styles.iconBorderInteractiveFilter, styles[colorStyleKey], styles[interactiveStyleKey], isSelected && styles.containerSelected),
      onClick: onClick,
      style: _objectSpread(_objectSpread({}, commonStyleOverrides), {}, {
        // Specified because Pressable has a default border:none which overrides the border specified on the container
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        border: "solid ".concat("var(--ds-border-width, 1px)", " ", isSelected ? "var(--ds-border-selected, #1868DB)" : 'transparent')
      }),
      testId: testId,
      analyticsContext: analyticsContext,
      interactionName: interactionName,
      componentName: "LozengeDropdownTrigger"
    }, innerContent);
  }
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    style: commonStyleOverrides,
    "data-testid": testId,
    className: ax([styles.container, styles[colorStyleKey], styles.iconBorderFilter])
  }, innerContent);
}));
export default LozengeBase;